export const NAME = "userManagement" as const;
export const DEFAULT_SIZE = 25 as const;
export const DEFAULT_PAGE = 0 as const;
export const DEFAULT_SORT = "username" as const;
export const SUBSCRIPTIONS_PAGE_SIZE_STORAGE_KEY = "outages.userManagement.subscriptionsPageSize" as const;
